const BUILDER_CDN_HOST = 'cdn.builder.io';

const DEFAULT_DESKTOP_WIDTH = 800;
const DEFAULT_MOBILE_WIDTH = 400;
const DEFAULT_FORMAT = 'webp';
const DEFAULT_QUALITY = 80;

function isBuilderCdnUrl(url) {
  if (!url || typeof url !== 'string') return false;
  try {
    return new URL(url).hostname === BUILDER_CDN_HOST;
  } catch {
    return url.includes(BUILDER_CDN_HOST);
  }
}

function isOptimizableImage(url) {
  if (!url || typeof url !== 'string') return false;
  if (/\.(svg|gif)(\?|$)/i.test(url)) return false;
  if (/\.(mp4|webm|mov|ogg)(\?|$)/i.test(url)) return false;
  return true;
}

export function optimizeBuilderImage(
  url,
  { width = DEFAULT_DESKTOP_WIDTH, format = DEFAULT_FORMAT, quality = DEFAULT_QUALITY } = {},
) {
  if (!isBuilderCdnUrl(url) || !isOptimizableImage(url)) return url;

  try {
    const parsed = new URL(url);
    if (!parsed.searchParams.has('width')) parsed.searchParams.set('width', String(width));
    if (!parsed.searchParams.has('format')) parsed.searchParams.set('format', format);
    if (!parsed.searchParams.has('quality')) parsed.searchParams.set('quality', String(quality));
    return parsed.toString();
  } catch {
    return url;
  }
}

export function optimizeBuilderImageResponsive(url) {
  return {
    desktop: optimizeBuilderImage(url, { width: DEFAULT_DESKTOP_WIDTH }),
    mobile: optimizeBuilderImage(url, { width: DEFAULT_MOBILE_WIDTH }),
  };
}

export { DEFAULT_DESKTOP_WIDTH, DEFAULT_MOBILE_WIDTH };
